import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserLogo: Getter<UserState, RootState> = (state) => {
  return state.current?.logo?.url || ''
}

export default getUserLogo
